export const ACCORDION = 'Accordion';
export const ACCORDION_ITEM = 'AccordionItem';
export const CARD_AUDIO_POPUP = 'CardAudioPopup';
export const CARD_IMAGE = 'CardImage';
export const AUDIO = 'Audio';
export const AUDIO_POPUP = 'AudioPopup';
export const VIDEO_POPUP = 'VideoPopup';
export const HORIZONTAL_AUDIO_PLAYER = 'HorizontalAudioPlayer';
export const BACKGROUND = 'Background';
export const BULLET = 'Bullet';
export const BULLET_LIST = 'BulletList';
export const CAROUSEL_NEXT = 'CarouselNext';
export const CAROUSEL_BACK = 'CarouselBack';
export const CAROUSEL_TINDER = 'CarouselTinder';
export const CARD = 'Card';
export const CAROUSEL = 'Carousel';
export const CHAPTER = 'Chapter';
export const CHAPTER_SELECTION = 'ChapterSelection';
export const CHART = 'Chart';
export const COLOR = 'Color';
export const COMPARISON = 'Comparison';
export const DRAG_AND_DROP_ZONE = 'DragAndDropZone';
export const DRAG_ITEM = 'DragItem';
export const DRAG_ZONE = 'DragZone';
export const DROP_ZONE = 'DropZone';
export const INFORMATION_DOOR = 'InformationalDoor';
export const QUIZ_DOOR = 'QuizDoor';
export const DOORS = 'Doors';
export const EMAIL = 'Email';
export const ENVELOPE = 'Envelope';
export const IPAD = 'Ipad';
export const FLIP_BACK = 'FlipBack';
export const FLIP_CARD = 'FlipCard';
export const FLIP_FRONT = 'FlipFront';
export const GAUGE = 'Gauge';
export const IMAGE = 'Image';
export const PERSONALIZED_CARD = 'PersonalizedCard';
export const INTRO_CARD = 'IntroCard';
export const LAYOUT_COLUMNS = 'LayoutColumns';
export const COLUMN = 'Column';
export const LAYOUT_COMICS = 'LayoutComics';
export const LAYOUT_GRID = 'LayoutGrid';
export const LAYOUT_HALF_PAGE = 'LayoutHalfPage';
export const LAYOUT_LIST = 'LayoutList';
export const LAYOUT_STATEMENT = 'LayoutStatement';
export const LAYOUT_TABLE = 'LayoutTable';
export const TABLE_ROW = 'TableRow';
export const TEXT_MESSAGES = 'TextMessages';
export const ADD_NEW_ITEM = 'AddNewItem';
export const MESSAGE = 'Message';
export const MESSAGE_RESPONSE = 'MessageResponse';
export const PHONE = 'Phone';
export const PHONE_NOTIFICATIONS = 'PhoneNotifications';
export const PIE_CHART = 'PieChart';
export const POPUP = 'Popup';
export const QUIZ_CHOICE = 'QuizChoice';
export const QUIZ_ORDER = 'QuizOrder';
export const QUIZ_ORDER_ITEM = 'QuizOrderItem';
export const QUIZ_INSTA = 'QuizInsta';
export const QUIZ_INSTA_SURVEY = 'QuizInstaSurvey';
export const ANSWER_BUTTON = 'AnswerButton';
export const BUTTON = 'Button';
export const HEADING_TEXT = 'HeadingText';
export const CLOSE_CARD = 'CloseCard';
export const PLAY_BUTTON = 'PlayButton';
export const BIG_PLAY_BUTTON = 'BigPlayButton';
export const QUIZ_MATCH = 'QuizMatch';
export const QUIZ_MATCH_BLOCK = 'QuizMatchBlock';
export const TABS = 'Tabs';
export const TAB = 'Tab';
export const TEXT = 'Text';
export const QUIZ_TEXT_FILL = 'QuizTextFill';
export const DROPDOWN = 'Dropdown';
export const TOOLTIP = 'Tooltip';
export const TWEET = 'Tweet';
export const TWEET_LOCK = 'TweetLock';
export const FBPOST = 'Fbpost';
export const VIDEO = 'Video';
export const ROOT = 'root';
export const DRAG_AND_DROP_CONTEXT_ROOT = 'DragAndDropContextRoot';
export const QUESTION_SEQUENCE = 'QuestionSequence';
export const QUESTION_BRANCHING = 'QuestionBranching';
export const IMAGE_MAP = 'ImageMap';
export const IMAGE_MAP2 = 'ImageMap2';
export const BUBBLE = 'Bubble';
export const MEMORY_GAME_MATCH_BLOCK = 'MemoryGameBlock';
export const MEMORY_GAME = 'MemoryGame';
export const CHART_PIE = 'ChartPie';
export const CHART_DOUGHNUT = 'ChartDoughnut';
export const CHART_POLAR = 'ChartPolar';
export const CHART_BAR = 'ChartBar';
export const CHART_LINE = 'ChartLine';
export const FIELDSET = 'Fieldset';
export const BUTTON_FOR_MULTIMEDIA2 = 'ButtonForMultimedia2';
export const PDF = 'Pdf';
export const LOGO = 'Logo';
export const FOLDER_BOX = 'FolderBox';
export const ADD_FOLDER = 'AddFolder';
export const STATIC_CARD = 'StaticCard';
export const STATIC_TEXT = 'StaticText';
export const FOLDER_GRID = 'FolderGrid';
export const CHAT_BOT = 'ChatBot';
export const ADD_CARD_PLACEHOLDER = 'AddCardPlaceholder';
export const EDITABLE_CARD_WRAPPER = 'EditableCardWrapper';
export const CARD_TYPE_SELECTION_PLACEHOLDER = 'CardTypeSelectionPlaceholder';
export const CARD_FORM_PLACEHOLDER = 'CardFormPlaceholder';
export const TEXT_WRAPPER = 'TextWrapper';
export const SCROLLABLE_CONTAINER = 'ScrollableContainer';
export const EDITABLE_LINK_BUTTON = 'EditableLinkButton';

export type ItemIds =
  | typeof ACCORDION
  | typeof ACCORDION_ITEM
  | typeof AUDIO
  | typeof AUDIO_POPUP
  | typeof HORIZONTAL_AUDIO_PLAYER
  | typeof BACKGROUND
  | typeof BULLET
  | typeof BULLET_LIST
  | typeof CAROUSEL_NEXT
  | typeof CAROUSEL_BACK
  | typeof CAROUSEL_TINDER
  | typeof CARD
  | typeof CAROUSEL
  | typeof CHAPTER
  | typeof CHAPTER_SELECTION
  | typeof CHART
  | typeof COLOR
  | typeof COMPARISON
  | typeof DRAG_AND_DROP_ZONE
  | typeof DRAG_ITEM
  | typeof DRAG_ZONE
  | typeof DROP_ZONE
  | typeof INFORMATION_DOOR
  | typeof QUIZ_DOOR
  | typeof DOORS
  | typeof EMAIL
  | typeof ENVELOPE
  | typeof IPAD
  | typeof FLIP_BACK
  | typeof FLIP_CARD
  | typeof FLIP_FRONT
  | typeof GAUGE
  | typeof IMAGE
  | typeof INTRO_CARD
  | typeof LAYOUT_COLUMNS
  | typeof COLUMN
  | typeof LAYOUT_COMICS
  | typeof LAYOUT_GRID
  | typeof LAYOUT_HALF_PAGE
  | typeof LAYOUT_LIST
  | typeof LAYOUT_STATEMENT
  | typeof LAYOUT_TABLE
  | typeof TABLE_ROW
  | typeof TEXT_MESSAGES
  | typeof CARD_AUDIO_POPUP
  | typeof MESSAGE
  | typeof MESSAGE_RESPONSE
  | typeof PHONE
  | typeof PHONE_NOTIFICATIONS
  | typeof PIE_CHART
  | typeof POPUP
  | typeof QUIZ_CHOICE
  | typeof QUIZ_ORDER
  | typeof QUIZ_ORDER_ITEM
  | typeof QUIZ_INSTA
  | typeof QUIZ_INSTA_SURVEY
  | typeof ANSWER_BUTTON
  | typeof BUTTON
  | typeof PLAY_BUTTON
  | typeof BIG_PLAY_BUTTON
  | typeof QUIZ_MATCH
  | typeof QUIZ_MATCH_BLOCK
  | typeof TABS
  | typeof TAB
  | typeof TEXT
  | typeof QUIZ_TEXT_FILL
  | typeof DROPDOWN
  | typeof TOOLTIP
  | typeof TWEET
  | typeof TWEET_LOCK
  | typeof FBPOST
  | typeof VIDEO
  | typeof ROOT
  | typeof DRAG_AND_DROP_CONTEXT_ROOT
  | typeof QUESTION_SEQUENCE
  | typeof QUESTION_BRANCHING
  | typeof IMAGE_MAP
  | typeof IMAGE_MAP2
  | typeof BUBBLE
  | typeof VIDEO_POPUP
  | typeof MEMORY_GAME_MATCH_BLOCK
  | typeof MEMORY_GAME
  | typeof CHART_PIE
  | typeof CHART_DOUGHNUT
  | typeof CHART_POLAR
  | typeof CHART_BAR
  | typeof CHART_LINE
  | typeof FIELDSET
  | typeof PERSONALIZED_CARD
  | typeof BUTTON_FOR_MULTIMEDIA2
  | typeof PDF
  | typeof LOGO
  | typeof CLOSE_CARD
  | typeof FOLDER_BOX
  | typeof CARD_IMAGE
  | typeof ADD_FOLDER
  | typeof STATIC_CARD
  | typeof STATIC_TEXT
  | typeof FOLDER_GRID
  | typeof ADD_CARD_PLACEHOLDER
  | typeof HEADING_TEXT
  | typeof CHAT_BOT
  | typeof ADD_NEW_ITEM
  | typeof EDITABLE_CARD_WRAPPER
  | typeof CARD_TYPE_SELECTION_PLACEHOLDER
  | typeof CARD_FORM_PLACEHOLDER
  | typeof TEXT_WRAPPER
  | typeof SCROLLABLE_CONTAINER
  | typeof EDITABLE_LINK_BUTTON;
